"use strict";
angular.module("core").directive("addressFrm", function() {
    return {
        scope: true,
        controller: function($scope, $attrs, $timeout, loaderGoogleMapAPI) {
            var _this = this;
            this.type = $attrs.type;
            this.formName = $attrs.formName;
            this.forceSubmittedState = $attrs.forceSubmittedState;

            var autocomplete;

            var componentForm = {
                street_number: this.type + "Address",
                route: this.type + "Address",
                locality: this.type + "City",
                administrative_area_level_1: this.type + "Province",
                country: this.type + "Country",
                postal_code: this.type + "PostalCode"
            };

            function initGoogleAutocompletePlace() {
                // because of the dynamic Id. This function need Angular finish the rending to be execute
                if (google && !autocomplete) {
                    autocomplete = new google.maps.places.Autocomplete(
                        document.getElementById("autocomplete" + _this.type), {types: ["geocode"]}
                    );

                    autocomplete.addListener("place_changed", fillInAddress);
                    $scope.$parent[_this.formName][_this.type + "Geolocalization"].$setValidity("notSelected", false);
                }
            };

            function fillInAddress() {
                var autoCompleteElement = document.getElementById("autocomplete" + _this.type);
                if (!autoCompleteElement) {
                    return;
                }

                if (autoCompleteElement.value.length === 0) {
                    return;
                }

                // Get the place details from the autocomplete object.
                var place = autocomplete.getPlace();

                if (place && place.address_components && place.address_components.length > 0) {
                    $scope.$parent[_this.formName][_this.type + "Geolocalization"].$setValidity("notSelected", true);

                    for (var component in componentForm) {
                        var componentElements = document.getElementsByName(componentForm[component]);
                        if (component === "country" || component === "administrative_area_level_1") {
                            componentElements = document.getElementsByName(componentForm[component] + "Name");
                        }

                        if (componentElements && componentElements[0]) {
                            var componentElement = componentElements[0];
                            componentElement.value = "";
                            componentElement.disabled = false;

                            angular.element(componentElement).triggerHandler("input");
                            angular.element(componentElement).triggerHandler("change"); // Added to fix issue with IE11
                        }
                    }

                    // Get each component of the address from the place details
                    // and fill the corresponding field on the form.
                    for (var i = 0; i < place.address_components.length; i++) {
                        var addressType = place.address_components[i].types[0];
                        // Depending on the Country, every place as its own structure. Need to get value according to our required data
                        if (componentForm[addressType]) {
                            if (addressType === "country" || addressType === "administrative_area_level_1") {
                                var inputAddressNames = document.getElementsByName(componentForm[addressType] + "Name");
                                if (inputAddressNames && inputAddressNames[0]) {
                                    var inputAddressName = inputAddressNames[0];
                                    inputAddressName.value = place.address_components[i].long_name;
                                    angular.element(inputAddressName).triggerHandler("input");
                                    angular.element(inputAddressName).triggerHandler("change"); // Added to fix issue with IE11
                                }

                                var inputAddressCodes = document.getElementsByName(componentForm[addressType] + "Code");
                                if (inputAddressCodes && inputAddressCodes[0]) {
                                    var inputAddressCode = inputAddressCodes[0];
                                    inputAddressCode.value = place.address_components[i].short_name;
                                    angular.element(inputAddressCode).triggerHandler("input");
                                    angular.element(inputAddressCode).triggerHandler("change"); // Added to fixe issue with IE11
                                }
                            }
                            else {
                                var addressElements = document.getElementsByName(componentForm[addressType]);
                                if (addressElements && addressElements[0]) {
                                    var addressElement = addressElements[0];
                                    if (addressType === "route") {
                                        addressElement.value += " ";
                                    }
                                    addressElement.value += place.address_components[i].long_name;
                                    angular.element(addressElement).triggerHandler("input");
                                    angular.element(addressElement).triggerHandler("change"); // Added to fix issue with IE11
                                }
                            }
                        }
                    }
                }
            }

            this.geolocate = function() {
                initGoogleAutocompletePlace();

                if (google && navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function(position) {
                        var geolocation = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        var circle = new google.maps.Circle({
                            center: geolocation,
                            radius: position.coords.accuracy
                        });
                        if (autocomplete) {
                            autocomplete.setBounds(circle.getBounds());
                        }
                    });
                }
            };

            loaderGoogleMapAPI.loadScript($scope.language);

            $scope.$watch("language", function(newVal, oldVal) {
                if (oldVal != newVal) {
                    autocomplete = null;
                    loaderGoogleMapAPI.loadScript(newVal);
                }
            });
        },
        controllerAs: "adrCtl",
        templateUrl: require("./address.directive.html")
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/address/address.directive.js
// module id = 492
// module chunks = 0